export default "__VITE_ASSET__c8355bf3__"